export function i18n(key) {
    if (window.lang !== 'undefined' && typeof window.i18nDictionary === 'function') {
        return window.i18nDictionary(window.lang, key);
    }
    return "i18nData." + window.lang.toUpperCase() + "." + key.toUpperCase();
}